import * as v from "valibot";

import { rpcContract } from "../rpc";

export const unfollowCreatorRpcContract = rpcContract({
  name: "unfollow-creator" as const,
  paramsSchema: v.object({
    influencerId: v.string(),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export type UnfollowCreatorParams = v.InferInput<typeof unfollowCreatorRpcContract.paramsSchema>;
export type UnfollowCreatorResult = v.InferOutput<typeof unfollowCreatorRpcContract.resultSchema>;
